/** Shared atmosphere for Orbit's Editorial public experiences.
 *  Kept as CSS-only decoration so Pages, Forms, Quiz, and Booking stay light,
 *  fast, and visually consistent without shipping image assets. */
export function EditorialBackdrop() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0" style={{
        background:
          'radial-gradient(55% 70% at 0% 0%, rgba(255,216,77,.27), transparent 72%), radial-gradient(52% 62% at 100% 0%, rgba(255,90,167,.14), transparent 70%), linear-gradient(180deg,#F5F0E8 0%,#F8F3EB 100%)',
      }} />
    </div>
  );
}

/** Restrained print rule used at the top of Editorial public surfaces. */
export function EditorialMotif() {
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 z-20 h-[3px] overflow-hidden" aria-hidden="true">
      <span className="absolute inset-0 bg-[linear-gradient(90deg,#FF5A1F_0_27%,#FF5AA7_27%_51%,#2458FF_51%_75%,#FFD84D_75%)]" />
    </div>
  );
}
